/** This export is automatically generated */
export const gitHash = 'bd547816';
